import React from "react"

function FormErrorMessage(props) {
  return <span className="text-danger">{props.errorMessage ?? ""}</span>
}

export default FormErrorMessage
